import { defineNuxtRouteMiddleware, useCookie, navigateTo } from "#imports";

// middleware/application.global.ts
export default defineNuxtRouteMiddleware((to, from) => {
  // URL 补斜杠
  const insertStr = "/";
  const prefixUrl = to.fullPath.match(/^[^\\#\\?]+/)?.[0];
  if (
    !prefixUrl?.endsWith("/") &&
    !prefixUrl?.includes("/sharkfoto/") &&
    !to.fullPath?.includes("?model=")
  ) {
    console.log("prefixUrl", prefixUrl);
    console.log("to.fullPath", to.fullPath);
    const suffix = to.fullPath.slice((prefixUrl?.length || 0));
    return navigateTo(`${prefixUrl}/${suffix}`);
  }

  // page-1 重定向
  if (to.params?.page === "1") {
    console.log("to.params?.page", to.params?.page);
    return navigateTo(to.fullPath.replace("page-1/", ""));
  }

  // referral 重定向
  const reffer = to.query?.r as string;
  if (reffer) {
    useCookie("sharkfoto_reffer_id").value = reffer;
    console.log("reffer", reffer);
    return navigateTo("/");
  }

  // bgremove 旧页面重定向
  // console.log("to.fullPath", to.fullPath);
  if (to.fullPath.includes("/app/?tool=bgremove")) {
    return navigateTo("/ai/image/background-remover/", { redirectCode: 301 });
  }

  if (to.fullPath.includes("/gallery/")) {
    return navigateTo("/", { redirectCode: 301 });
  }

  if (to.fullPath.endsWith("/ai/") || to.fullPath.endsWith("/app/")) {
    return navigateTo("/ai/image/text-to-image/", { redirectCode: 301 });
  }

  // /app/?tool=xxx工具定向到/free-tools/image/xxx
  if (to.fullPath.includes("/app/?tool=")) {
    let tool = to.query?.tool as string;
    if (tool === "flip") {
      tool = "flipper";
    }
    if (tool === "rotate") {
      tool = "rotator";
    }
    const aitoolMap: Record<string, string> = {
      bgremove: "background-remover",
      enhancer: "color-enhancer",
      enlarger: "image-upscaler",
      colorize: "image-colorizer",
    };
    if (aitoolMap?.[tool]) {
      return navigateTo(`/ai/image/${aitoolMap[tool]}/`, { redirectCode: 301,external: true });
    }

    return navigateTo(`/free-tools/image/${tool}/`, { redirectCode: 301,external: true });
  }
});
